import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
const columns = [{
  slots: {
    title: '模版名称'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center'
}, {
  slots: {
    title: '模版类型'
  },
  dataIndex: 'type',
  key: 'type',
  align: 'center'
}, {
  slots: {
    title: '控件'
  },
  dataIndex: 'control',
  key: 'control',
  align: 'center',
  scopedSlots: {
    customRender: 'control'
  }
}, {
  slots: {
    title: '必填'
  },
  dataIndex: 'isRequired',
  key: 'isRequired',
  align: 'center',
  scopedSlots: {
    customRender: 'isRequired'
  }
}, {
  slots: {
    title: '生成标签'
  },
  dataIndex: 'isTag',
  key: 'isTag',
  align: 'center',
  scopedSlots: {
    customRender: 'isTag'
  }
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'operation',
  key: 'operation',
  align: 'center',
  width: 250,
  scopedSlots: {
    customRender: 'operation'
  }
}];
import topTitle from '@/components/title';
import { uploadFile } from '@/views/customer/applicationManage/request';
import previewMobile from './previewMobile.vue';
import { templateStore, mainDetailV2 } from '../request';
import { controllist } from '../../templateManage/request';
import { cryptoDecrypt } from '@/utils/aes';
import templateModal from '../components/templateModal/index.vue';
export default {
  props: ['id', 'info'],
  components: {
    topTitle,
    previewMobile,
    templateModal
  },
  data() {
    return {
      columns,
      insureTableData: [],
      //投保模版table数据
      typeList: [],
      //投保模版数据
      form: {},
      action: uploadFile,
      batchTemplateName: '',
      fileList: [],
      addVisible: false,
      currentType: undefined,
      filterName: '',
      showAll: false,
      previewVisible: false,
      setVisible: false,
      settingCode: 0,
      currentSetIndex: undefined,
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
        marginLeft: '20px'
      },
      batchTemplate: '',
      oldbatchTemplate: '',
      controllist,
      templateType: 1,
      //1:投保模版 2:退保模版
      cancelTypeList: [],
      //退保模版数据
      cancelInsureTableData: [],
      //退保模版table数据
      showAllCancel: false,
      setTimeVisible: false,
      //高级设置：起保时间
      advancedConfig: 'Ymd' //高级设置：起保时间时间格式：Ymd,YmdH,YmdHi
    };
  },
  mounted() {
    mainDetailV2({
      insuranceId: this.id
    }).then(res => {
      this.batchTemplate = res.batchTemplate;
      this.oldbatchTemplate = res.batchTemplate;
      this.batchTemplateName = res.batchTemplateName;
      this.typeList = res.rendering;
      this.insureTableData = this.filterAddData(this.typeList);
      // 退保模版数据
      this.cancelTypeList = res.renderingCancel;
      this.cancelInsureTableData = this.filterAddData(this.cancelTypeList);
    });
  },
  methods: {
    delBatch() {
      this.batchTemplateName = '';
      this.oldbatchTemplate = '';
      this.batchTemplate = '';
      this.$message.success(this.$t('操作成功'));
    },
    // 是否必填、是否生成标签
    changeIs(e, info, key) {
      if (e.target.checked) {
        info[key] = 1;
      } else {
        info[key] = 0;
      }
    },
    isNumber(info) {
      let arr = ['投保人手机号', '被保人手机号', '受益人手机号'];
      if (arr.includes(info.name)) {
        return true;
      }
      return false;
    },
    filterAddData(data, table = []) {
      let newData = [];
      data.map(item => {
        if (item.item && item.item.length) {
          item.item.map(info => {
            if (info.selected) {
              let finded = table.find(i => i.id == info.id);
              console.log(finded, '--------finded-------');
              let obj = {
                id: info.id,
                insureTemplateId: info.id,
                name: info.name,
                type: item.name,
                control: info.display,
                isRequired: finded ? finded.isRequired : info.isRequired,
                isTag: finded ? finded.isTag : info.isTag,
                isSend: finded ? finded.isSend : info.isSend,
                advancedConfig: finded ? finded.advancedConfig : info.advancedConfig
              };
              newData.push(obj);
            }
          });
        }
      });
      return newData;
    },
    handleChange({
      file,
      fileList
    }) {
      console.log(file);
      const isThanMax = file.size / 1024 / 1024 < 5;
      if (!isThanMax) {
        return this.$message.error(this.$t('文件过大，请选择5M以下文件上传'));
      }
      if (file.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        return this.$message.error(this.$t('仅支持上传xlsx格式文件'));
      }
      fileList = fileList.map(file => {
        if (file.response) {
          file.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        }
        return file;
      });
      this.fileList = fileList.length != 0 ? [fileList[fileList.length - 1]] : [];
      this.batchTemplateName = this.fileList.length != 0 ? this.fileList[0].name : '';
      this.batchTemplate = this.fileList.length != 0 ? this.fileList[0].url : '';
    },
    // 删除投保模版、删除退保模版
    delList(info, i, templateType) {
      if (templateType === 'insure') {
        this.insureTableData.splice(i, 1);
        this.typeList.forEach(item => {
          if (item.item && item.item.length) {
            item.item.forEach(item1 => {
              if (item1.id == info.id) {
                item1.selected = false;
                item1.isSend = 0;
                item1.isTag = 0;
                item1.isRequired = 1;
                item1.advancedConfig = 'Ymd';
              }
            });
          }
        });
        this.$message.success(this.$t('操作成功'));
      } else if (templateType === 'cancelInsure') {
        this.cancelInsureTableData.splice(i, 1);
        this.cancelTypeList.forEach(item => {
          if (item.item && item.item.length) {
            item.item.forEach(item1 => {
              if (item1.id == info.id) {
                item1.selected = false;
                item1.isSend = 0;
                item1.isTag = 0;
                item1.isRequired = 1;
              }
            });
          }
        });
        this.$message.success(this.$t('操作成功'));
      }
    },
    // 增加投保模版
    addTemplate() {
      this.addVisible = true;
      this.templateType = 1;
    },
    // 增加退保模版
    addPolicyCancelTemplate() {
      this.addVisible = true;
      this.templateType = 2;
    },
    //保存模版回调
    onSave(data) {
      if (this.templateType == 1) {
        this.insureTableData = data;
      } else {
        this.cancelInsureTableData = data;
      }
    },
    // 点击高级设置
    onSettingCli(info, i, templateType) {
      this.currentSetIndex = i;
      if (templateType == 'insure') {
        this.templateType = 1;
      } else {
        this.templateType = 2;
      }
      // 回显是否发送验证码
      if (info.isSend) {
        this.settingCode = 1;
      } else {
        this.settingCode = 0;
      }
      // 回显时间控件
      if (info.advancedConfig) {
        this.advancedConfig = info.advancedConfig;
      } else {
        this.advancedConfig = 'Ymd';
      }
      console.log(info, 'info');
      if (info.control == 'time') {
        console.log('起保时间高级设置');
        this.setTimeVisible = true;
      } else {
        this.setVisible = true;
      }
    },
    // 高级设置保存
    onSaveSetting() {
      if (this.templateType == 1) {
        this.insureTableData[this.currentSetIndex].isSend = this.settingCode;
      } else {
        this.cancelInsureTableData[this.currentSetIndex].isSend = this.settingCode;
      }
      this.setVisible = false;
    },
    onSaveTimeSetting() {
      if (this.templateType == 1) {
        this.insureTableData[this.currentSetIndex].advancedConfig = this.advancedConfig;
      } else {
        this.cancelInsureTableData[this.currentSetIndex].advancedConfig = this.advancedConfig;
      }
      this.setTimeVisible = false;
    },
    // 预览模版
    previewCli(templateType) {
      if (templateType == 'insure') {
        this.templateType = 1;
      } else {
        this.templateType = 2;
      }
      this.previewVisible = true;
    },
    nextFun() {
      if (this.insureTableData.length && this.cancelInsureTableData.length) {
        this.saveData();
        this.$emit('next');
        return;
      }
      let that = this;
      this.$confirm({
        title: that.$t('当前产品未配置投保模版，可能会无法正常使用客户端（APP、H5）投保、后台录入保单等关联功能，是否继续下一步') + '？',
        // content: h => <div style="color:red;">Some descriptions</div>,
        okText: that.$t('下一步'),
        onOk() {
          that.saveData();
          that.$emit('next');
        },
        onCancel() {
          console.log('Cancel');
        },
        class: 'test'
      });
    },
    prevFun() {
      this.saveData();
      this.$emit('prev');
    },
    async saveData() {
      let obj = {
        batchTemplate: this.oldbatchTemplate === this.batchTemplate ? '' : this.batchTemplate,
        batchTemplateName: this.batchTemplateName || '',
        insureData: this.insureTableData,
        cancelData: this.cancelInsureTableData,
        insuranceId: this.id
      };
      await templateStore(obj);
    },
    controlFun(val) {
      console.log(val, 'val');
      // let const ='';
      const obj = this.controllist.find(item => item.id == val);
      return obj.name;
    }
  }
};